<template>
    <div>
        <slot :event="event" :imageUrl="imageUrl"></slot>
    </div>
</template>

<script>
import { defineComponent, ref, watch, inject} from 'vue';
import { uniq } from 'lodash';

export default defineComponent({
    name: 'SeriesPackItem',
    props: {
        event: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const event = ref({});
        const imageUrl = inject('imageUrl');

        watch(
            () => props.event,
            (newEvent) => {
                event.value = newEvent;
            },
            { immediate: true }
        );

        return {
            event: event,
            imageUrl: imageUrl
        }
    }
});
</script>


